import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="pt-40 pb-24 mx-auto max-w-xl px-5 text-center">
      <span className="grid place-items-center h-20 w-20 rounded-full bg-secondary text-muted-foreground mx-auto"><XCircle size={44} /></span>
      <h1 className="mt-6 font-heading text-3xl font-extrabold text-foreground">Checkout cancelled</h1>
      <p className="mt-3 text-muted-foreground">No worries — your cart is saved. You can resume checkout anytime or request a wholesale quote instead.</p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/cart" className="inline-flex items-center gap-2 rounded-full bg-navy text-white px-7 py-3.5 font-semibold hover:bg-royal transition-colors">Return to cart <ArrowRight size={18} /></Link>
        <Link to="/products" className="inline-flex items-center gap-2 rounded-full border border-border px-7 py-3.5 font-semibold hover:bg-secondary transition-colors">Keep browsing</Link>
      </div>
    </div>
  );
}
